const css = `@keyframes _toolbarEnter_v3b7v_1 {
  from {
    opacity: 0;
    transform: scale(0.5) rotate(90deg);
  }
  to {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
}
@keyframes _badgeEnter_v3b7v_1 {
  from {
    opacity: 0;
    transform: scale(0);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes _markerIn_v3b7v_1 {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.3);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}
@keyframes _markerOut_v3b7v_1 {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.3);
  }
}
@keyframes _fadeIn_v3b7v_1 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes _fadeOut_v3b7v_1 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes _hoverHighlightIn_v3b7v_1 {
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes _hoverTooltipIn_v3b7v_1 {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(4px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes _tooltipIn_v3b7v_1 {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(2px) scale(0.909);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0) scale(0.909);
  }
}
._toolbar_v3b7v_87 {
  all: initial !important;
  position: fixed !important;
  bottom: 1.25rem !important;
  right: 1.25rem !important;
  z-index: 2147483647 !important;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
  font-size: 14px !important;
  line-height: 1.4 !important;
  color: #fff !important;
  pointer-events: none !important;
  transition: left 0s, top 0s, right 0s, bottom 0s !important;
  box-sizing: border-box !important;
}
._toolbar_v3b7v_87 * {
  box-sizing: border-box !important;
}

._toolbarContainer_v3b7v_105 {
  all: unset !important;
  box-sizing: border-box !important;
  user-select: none !important;
  margin-left: auto !important;
  align-self: flex-end !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: #1a1a1a !important;
  color: #fff !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2), 0 4px 16px rgba(0, 0, 0, 0.1) !important;
  pointer-events: auto !important;
  cursor: grab !important;
  height: 44px !important;
  border-radius: 22px !important;
  font-family: inherit !important;
  font-size: inherit !important;
  transition: clip-path 0.4s cubic-bezier(0.19, 1, 0.22, 1), transform 0.4s cubic-bezier(0.19, 1, 0.22, 1) !important;
}
._toolbarContainer_v3b7v_105._dragging_v3b7v_126 {
  transition: clip-path 0.4s cubic-bezier(0.19, 1, 0.22, 1) !important;
  cursor: grabbing !important;
}
._toolbarContainer_v3b7v_105._entrance_v3b7v_130 {
  animation: _toolbarEnter_v3b7v_1 0.5s cubic-bezier(0.34, 1.2, 0.64, 1) forwards !important;
}
._toolbarContainer_v3b7v_105._collapsed_v3b7v_133 {
  padding: 0 12px !important;
  cursor: pointer !important;
  clip-path: inset(0 0 0 calc(100% - 44px) round 22px) !important;
}
._toolbarContainer_v3b7v_105._collapsed_v3b7v_133 svg {
  margin-top: -1px !important;
}
._toolbarContainer_v3b7v_105._collapsed_v3b7v_133:hover {
  background: #2a2a2a !important;
}
._toolbarContainer_v3b7v_105._collapsed_v3b7v_133:active {
  transform: scale(0.95) !important;
}
._toolbarContainer_v3b7v_105._expanded_v3b7v_147 {
  padding: 0.375rem !important;
  clip-path: inset(-100px -80px 0 -80px round 22px) !important;
}

._badge_v3b7v_152 {
  position: absolute;
  top: -16px;
  right: -16px;
  user-select: none;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #3c82f7;
  color: white;
  font-size: 0.625rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  pointer-events: none;
  z-index: 1;
}
._badge_v3b7v_152._entrance_v3b7v_130 {
  animation: _badgeEnter_v3b7v_1 0.3s cubic-bezier(0.34, 1.2, 0.64, 1) 0.4s both;
}

._toggleContent_v3b7v_176 {
  position: absolute;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.15s cubic-bezier(0.19, 1, 0.22, 1);
}
._toggleContent_v3b7v_176._visible_v3b7v_184 {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}
._toggleContent_v3b7v_176._hidden_v3b7v_189 {
  opacity: 0;
  pointer-events: none;
}

._controlsContent_v3b7v_194 {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  transition: filter 0.8s cubic-bezier(0.19, 1, 0.22, 1), opacity 0.8s cubic-bezier(0.19, 1, 0.22, 1), transform 0.6s cubic-bezier(0.19, 1, 0.22, 1);
}
._controlsContent_v3b7v_194._visible_v3b7v_184 {
  opacity: 1;
  filter: blur(0px);
  transform: scale(1);
  visibility: visible;
  pointer-events: auto;
}
._controlsContent_v3b7v_194._hidden_v3b7v_189 {
  opacity: 0;
  filter: blur(10px);
  transform: scale(0.4);
  pointer-events: none;
}

@keyframes _hintIn_v3b7v_1 {
  from {
    opacity: 0;
    transform: translateX(-10px);
    max-width: 0;
    padding: 0;
    margin-right: 0;
  }
  to {
    opacity: 1;
    transform: translateX(0);
    max-width: 100px;
    padding: 0 0.5rem 0 0.375rem;
    margin-right: 0.25rem;
  }
}
@keyframes _hintOut_v3b7v_1 {
  from {
    opacity: 1;
    transform: translateX(0);
    max-width: 100px;
    padding: 0 0.5rem 0 0.375rem;
    margin-right: 0.25rem;
  }
  to {
    opacity: 0;
    transform: translateX(10px);
    max-width: 0;
    padding: 0;
    margin-right: 0;
  }
}
._annotationHint_v3b7v_246 {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0 0.5rem 0 0.375rem;
  height: 34px;
  background: rgba(60, 130, 247, 0.15);
  border-radius: 17px;
  margin-right: 0.25rem;
  animation: _hintIn_v3b7v_1 0.25s cubic-bezier(0.22, 1, 0.36, 1) forwards;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer !important;
  user-select: none;
  transition: background-color 0.15s ease, transform 0.1s ease;
}
._annotationHint_v3b7v_246:hover {
  background: rgba(60, 130, 247, 0.25);
}
._annotationHint_v3b7v_246:active {
  transform: scale(0.92);
}
._annotationHint_v3b7v_246._exit_v3b7v_268 {
  animation: _hintOut_v3b7v_1 0.2s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

._annotationCount_v3b7v_272 {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: #3c82f7;
  color: white;
  font-size: 0.6875rem;
  font-weight: 600;
}

._divider_v3b7v_286 {
  width: 1px;
  height: 20px;
  background: rgba(255, 255, 255, 0.15);
  margin: 0 0.125rem;
}

._controlButton_v3b7v_293 {
  all: unset;
  box-sizing: border-box !important;
  position: relative;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 34px !important;
  height: 34px !important;
  min-width: 34px !important;
  min-height: 34px !important;
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 50% !important;
  border: none !important;
  background: transparent !important;
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: inherit !important;
  line-height: 1 !important;
  transition: background-color 0.15s ease, color 0.15s ease, transform 0.1s ease, opacity 0.2s ease;
  overflow: visible !important;
}
._controlButton_v3b7v_293 svg {
  width: auto;
  height: auto;
  color: inherit;
  fill: currentColor;
}
._controlButton_v3b7v_293:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}
._controlButton_v3b7v_293:active:not(:disabled) {
  transform: scale(0.92);
}
._controlButton_v3b7v_293:disabled {
  opacity: 0.35 !important;
  cursor: not-allowed !important;
}
._controlButton_v3b7v_293[data-active=true] {
  color: #3c82f7 !important;
  background: rgba(60, 130, 247, 0.25) !important;
}
._controlButton_v3b7v_293[data-active=true]:hover:not(:disabled) {
  background: rgba(60, 130, 247, 0.35) !important;
}
._controlButton_v3b7v_293[data-danger]:hover:not(:disabled) {
  background: rgba(255, 59, 48, 0.25) !important;
  color: #ff3b30 !important;
}

._buttonWrapper_v3b7v_345 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
}
._buttonWrapper_v3b7v_345:hover ._buttonTooltip_v3b7v_352 {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) scale(1);
  transition-delay: 0.85s;
}
._buttonWrapper_v3b7v_345:has(._controlButton_v3b7v_293:disabled):hover ._buttonTooltip_v3b7v_352 {
  opacity: 0;
  visibility: hidden;
}

._buttonTooltip_v3b7v_352 {
  position: absolute;
  bottom: calc(100% + 14px);
  left: 50%;
  transform: translateX(-50%) scale(0.95);
  padding: 6px 10px;
  background: #1a1a1a;
  color: rgba(255, 255, 255, 0.9);
  font-size: 12px;
  font-weight: 500;
  border-radius: 8px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: 100001;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transition: opacity 0.135s ease, transform 0.135s ease, visibility 0.135s ease, background-color 0.15s ease;
  user-select: none;
}
._buttonTooltip_v3b7v_352::after {
  content: "";
  position: absolute;
  top: calc(100% - 4px);
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 8px;
  height: 8px;
  background: #1a1a1a;
  border-radius: 0 0 2px 0;
}

._clickableTooltip_v3b7v_395 {
  pointer-events: auto !important;
  cursor: pointer !important;
  transition: background-color 0.15s ease, transform 0.1s ease;
}
._clickableTooltip_v3b7v_395:hover {
  background: #2a2a2a !important;
}
._clickableTooltip_v3b7v_395:active {
  transform: translateX(-50%) scale(0.95);
}

._overlay_v3b7v_407 {
  position: fixed;
  inset: 0;
  z-index: 99997;
  pointer-events: none;
}
._overlay_v3b7v_407 > * {
  pointer-events: auto;
}

._hoverHighlight_v3b7v_417 {
  position: fixed;
  border: 2px solid rgba(60, 130, 247, 0.5);
  border-radius: 4px;
  pointer-events: none !important;
  background: rgba(60, 130, 247, 0.04);
  box-sizing: border-box;
  will-change: opacity;
  contain: layout style;
}
._hoverHighlight_v3b7v_417._enter_v3b7v_427 {
  animation: _hoverHighlightIn_v3b7v_1 0.12s ease-out forwards;
}

._hoverTooltip_v3b7v_431 {
  position: fixed;
  font-size: 0.6875rem;
  font-weight: 500;
  color: #fff;
  background: rgba(0, 0, 0, 0.9);
  padding: 0.4rem 0.6rem;
  border-radius: 0.5rem;
  pointer-events: none !important;
  max-width: 320px;
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
._hoverTooltip_v3b7v_431._enter_v3b7v_427 {
  animation: _hoverTooltipIn_v3b7v_1 0.1s ease-out forwards;
}

._hoverTooltipMain_v3b7v_448 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

._hoverTooltipProps_v3b7v_454 {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem 0.5rem;
  margin-top: 0.35rem;
  padding-top: 0.35rem;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace;
  font-size: 0.625rem;
}

._propItem_v3b7v_465 {
  display: inline-flex;
  align-items: center;
  gap: 0.125rem;
}

._propKey_v3b7v_471 {
  color: #ffa94d;
}

._propEquals_v3b7v_475 {
  color: rgba(255, 255, 255, 0.5);
}

._propValue_v3b7v_479 {
  color: #69db7c;
}

._propMore_v3b7v_483 {
  color: rgba(255, 255, 255, 0.4);
  font-style: italic;
}

._reactComponent_v3b7v_488 {
  color: #61dafb;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace;
}

._reactHierarchy_v3b7v_493 {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.625rem;
}

._singleSelectOutline_v3b7v_498 {
  position: fixed;
  border: 2px solid rgba(60, 130, 247, 0.6);
  border-radius: 4px;
  pointer-events: none !important;
  background: rgba(60, 130, 247, 0.05);
  box-sizing: border-box;
  will-change: opacity;
}
._singleSelectOutline_v3b7v_498._enter_v3b7v_427 {
  animation: _fadeIn_v3b7v_1 0.15s ease-out forwards;
}
._singleSelectOutline_v3b7v_498._exit_v3b7v_268 {
  animation: _fadeOut_v3b7v_1 0.15s ease-out forwards;
}

._markersLayer_v3b7v_514 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 0;
  z-index: 99998;
  pointer-events: none;
}
._markersLayer_v3b7v_514 > * {
  pointer-events: auto;
}

._marker_v3b7v_514 {
  position: absolute;
  width: 22px;
  height: 22px;
  background: #3c82f7;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6875rem;
  font-weight: 600;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  border: none;
  outline: none;
  user-select: none;
  will-change: transform, opacity;
  contain: layout style;
  z-index: 1;
}
._marker_v3b7v_514:hover {
  z-index: 2;
}
._marker_v3b7v_514:not(._enter_v3b7v_427):not(._exit_v3b7v_268):not(._clearing_v3b7v_553) {
  transition: background-color 0.15s ease, transform 0.1s ease;
}
._marker_v3b7v_514._enter_v3b7v_427 {
  animation: _markerIn_v3b7v_1 0.25s cubic-bezier(0.22, 1, 0.36, 1) both;
}
._marker_v3b7v_514._exit_v3b7v_268 {
  animation: _markerOut_v3b7v_1 0.2s ease-out both;
  pointer-events: none;
}
._marker_v3b7v_514._clearing_v3b7v_553 {
  animation: _markerOut_v3b7v_1 0.15s ease-out both;
  pointer-events: none;
}
._marker_v3b7v_514:not(._enter_v3b7v_427):not(._exit_v3b7v_268):not(._clearing_v3b7v_553):hover {
  transform: translate(-50%, -50%) scale(1.1);
}
._marker_v3b7v_514._fixed_v3b7v_570 {
  position: fixed;
}
._marker_v3b7v_514._hovered_v3b7v_573 {
  background: #ff3b30;
}

._markerTooltip_v3b7v_577 {
  position: absolute;
  top: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%) scale(0.909);
  z-index: 100002;
  background: #1a1a1a;
  padding: 8px 0.75rem;
  border-radius: 0.75rem;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-weight: 400;
  color: #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.08);
  min-width: 120px;
  max-width: 200px;
  pointer-events: none;
  cursor: default;
}
._markerTooltip_v3b7v_577._enter_v3b7v_427 {
  animation: _tooltipIn_v3b7v_1 0.1s ease-out forwards;
}

._markerQuote_v3b7v_599 {
  display: block;
  font-size: 12px;
  font-style: italic;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 0.3125rem;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

._markerNote_v3b7v_611 {
  display: block;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: 2px;
}

._markerHint_v3b7v_623 {
  display: block;
  font-size: 0.625rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 0.375rem;
  white-space: nowrap;
}

@keyframes _shiftHighlightPulse_v3b7v_1 {
  0%, 100% {
    opacity: 0.8;
  }
  50% {
    opacity: 1;
  }
}
@keyframes _shiftPanelIn_v3b7v_1 {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes _shiftPanelOut_v3b7v_1 {
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(8px) scale(0.95);
  }
}
._shiftOverlay_v3b7v_660 {
  position: fixed;
  inset: 0;
  z-index: 99996;
  pointer-events: none;
}

._shiftHighlight_v3b7v_667 {
  position: fixed;
  border: 2px solid rgba(255, 152, 0, 0.9);
  background: rgba(255, 152, 0, 0.12);
  border-radius: 4px;
  pointer-events: none;
  box-sizing: border-box;
  animation: _shiftHighlightPulse_v3b7v_1 2s ease-in-out infinite;
}
._shiftHighlight_v3b7v_667._enter_v3b7v_427 {
  animation: _hoverHighlightIn_v3b7v_1 0.15s ease-out forwards, _shiftHighlightPulse_v3b7v_1 2s ease-in-out 0.15s infinite;
}

._shiftPreviousRect_v3b7v_680 {
  position: fixed;
  border: 2px dashed rgba(255, 152, 0, 0.5);
  background: rgba(255, 152, 0, 0.05);
  border-radius: 4px;
  pointer-events: none;
  box-sizing: border-box;
}

._shiftCurrentRect_v3b7v_689 {
  position: fixed;
  border: 2px solid rgba(255, 152, 0, 0.8);
  background: rgba(255, 152, 0, 0.1);
  border-radius: 4px;
  pointer-events: none;
  box-sizing: border-box;
}

._clsBadge_v3b7v_698 {
  position: absolute;
  top: -12px;
  right: 90px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  font-size: 0.625rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  pointer-events: none;
  z-index: 1;
  white-space: nowrap;
}
._clsBadge_v3b7v_698._good_v3b7v_716 {
  background: #34c759;
  color: white;
}
._clsBadge_v3b7v_698._needsImprovement_v3b7v_720 {
  background: #ff9800;
  color: white;
}
._clsBadge_v3b7v_698._poor_v3b7v_724 {
  background: #ff3b30;
  color: white;
}

._shiftPanel_v3b7v_729 {
  width: 280px;
  max-height: 320px;
  background: #1a1a1a;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.08);
  overflow: hidden;
  z-index: 100001;
  animation: _shiftPanelIn_v3b7v_1 0.15s ease-out forwards;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  pointer-events: auto;
}
._shiftPanel_v3b7v_729._exiting_v3b7v_741 {
  animation: _shiftPanelOut_v3b7v_1 0.12s ease-out forwards;
}

._shiftPanelHeader_v3b7v_745 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

._shiftPanelTitle_v3b7v_753 {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
}

._shiftPanelScore_v3b7v_759 {
  font-size: 12px;
  font-weight: 500;
  padding: 3px 8px;
  border-radius: 6px;
}
._shiftPanelScore_v3b7v_759._good_v3b7v_716 {
  background: rgba(52, 199, 89, 0.2);
  color: #34c759;
}
._shiftPanelScore_v3b7v_759._needsImprovement_v3b7v_720 {
  background: rgba(255, 152, 0, 0.2);
  color: #ff9800;
}
._shiftPanelScore_v3b7v_759._poor_v3b7v_724 {
  background: rgba(255, 59, 48, 0.2);
  color: #ff3b30;
}

._shiftPanelControls_v3b7v_778 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

._shiftFilterSelect_v3b7v_786 {
  flex: 1;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 12px;
  padding: 6px 10px;
  cursor: pointer;
  outline: none;
}
._shiftFilterSelect_v3b7v_786:hover {
  background: rgba(255, 255, 255, 0.12);
}
._shiftFilterSelect_v3b7v_786:focus {
  box-shadow: 0 0 0 2px rgba(60, 130, 247, 0.4);
}
._shiftFilterSelect_v3b7v_786 option {
  background: #1a1a1a;
  color: #fff;
}

._shiftClearButton_v3b7v_808 {
  background: rgba(255, 59, 48, 0.2);
  border: none;
  border-radius: 6px;
  color: #ff3b30;
  font-size: 11px;
  font-weight: 500;
  padding: 6px 10px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
._shiftClearButton_v3b7v_808:hover {
  background: rgba(255, 59, 48, 0.3);
}
._shiftClearButton_v3b7v_808:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

._shiftList_v3b7v_827 {
  max-height: 200px;
  overflow-y: auto;
  padding: 6px;
}
._shiftList_v3b7v_827::-webkit-scrollbar {
  width: 6px;
}
._shiftList_v3b7v_827::-webkit-scrollbar-track {
  background: transparent;
}
._shiftList_v3b7v_827::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
._shiftList_v3b7v_827::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

._shiftListEmpty_v3b7v_846 {
  padding: 20px 14px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
}

._shiftItem_v3b7v_853 {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
._shiftItem_v3b7v_853:hover {
  background: rgba(255, 255, 255, 0.06);
}
._shiftItem_v3b7v_853:active {
  background: rgba(255, 255, 255, 0.1);
}

._shiftItemValue_v3b7v_869 {
  min-width: 42px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  border-radius: 4px;
  background: rgba(255, 152, 0, 0.2);
  color: #ff9800;
}

._shiftItemContent_v3b7v_882 {
  flex: 1;
  min-width: 0;
}

._shiftItemDescription_v3b7v_887 {
  font-size: 12px;
  color: #fff;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

._shiftItemTime_v3b7v_896 {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 2px;
}

._shiftItemReplay_v3b7v_902 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
  flex-shrink: 0;
}
._shiftItemReplay_v3b7v_902:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}
._shiftItemReplay_v3b7v_902 svg {
  width: 14px;
  height: 14px;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {"toolbar":"_toolbar_v3b7v_87","toolbarContainer":"_toolbarContainer_v3b7v_105","dragging":"_dragging_v3b7v_126","entrance":"_entrance_v3b7v_130","toolbarEnter":"_toolbarEnter_v3b7v_1","collapsed":"_collapsed_v3b7v_133","expanded":"_expanded_v3b7v_147","badge":"_badge_v3b7v_152","badgeEnter":"_badgeEnter_v3b7v_1","toggleContent":"_toggleContent_v3b7v_176","visible":"_visible_v3b7v_184","hidden":"_hidden_v3b7v_189","controlsContent":"_controlsContent_v3b7v_194","annotationHint":"_annotationHint_v3b7v_246","hintIn":"_hintIn_v3b7v_1","exit":"_exit_v3b7v_268","hintOut":"_hintOut_v3b7v_1","annotationCount":"_annotationCount_v3b7v_272","divider":"_divider_v3b7v_286","controlButton":"_controlButton_v3b7v_293","buttonWrapper":"_buttonWrapper_v3b7v_345","buttonTooltip":"_buttonTooltip_v3b7v_352","clickableTooltip":"_clickableTooltip_v3b7v_395","overlay":"_overlay_v3b7v_407","hoverHighlight":"_hoverHighlight_v3b7v_417","enter":"_enter_v3b7v_427","hoverHighlightIn":"_hoverHighlightIn_v3b7v_1","hoverTooltip":"_hoverTooltip_v3b7v_431","hoverTooltipIn":"_hoverTooltipIn_v3b7v_1","hoverTooltipMain":"_hoverTooltipMain_v3b7v_448","hoverTooltipProps":"_hoverTooltipProps_v3b7v_454","propItem":"_propItem_v3b7v_465","propKey":"_propKey_v3b7v_471","propEquals":"_propEquals_v3b7v_475","propValue":"_propValue_v3b7v_479","propMore":"_propMore_v3b7v_483","reactComponent":"_reactComponent_v3b7v_488","reactHierarchy":"_reactHierarchy_v3b7v_493","singleSelectOutline":"_singleSelectOutline_v3b7v_498","fadeIn":"_fadeIn_v3b7v_1","fadeOut":"_fadeOut_v3b7v_1","markersLayer":"_markersLayer_v3b7v_514","marker":"_marker_v3b7v_514","clearing":"_clearing_v3b7v_553","markerIn":"_markerIn_v3b7v_1","markerOut":"_markerOut_v3b7v_1","fixed":"_fixed_v3b7v_570","hovered":"_hovered_v3b7v_573","markerTooltip":"_markerTooltip_v3b7v_577","tooltipIn":"_tooltipIn_v3b7v_1","markerQuote":"_markerQuote_v3b7v_599","markerNote":"_markerNote_v3b7v_611","markerHint":"_markerHint_v3b7v_623","shiftOverlay":"_shiftOverlay_v3b7v_660","shiftHighlight":"_shiftHighlight_v3b7v_667","shiftHighlightPulse":"_shiftHighlightPulse_v3b7v_1","shiftPreviousRect":"_shiftPreviousRect_v3b7v_680","shiftCurrentRect":"_shiftCurrentRect_v3b7v_689","clsBadge":"_clsBadge_v3b7v_698","good":"_good_v3b7v_716","needsImprovement":"_needsImprovement_v3b7v_720","poor":"_poor_v3b7v_724","shiftPanel":"_shiftPanel_v3b7v_729","shiftPanelIn":"_shiftPanelIn_v3b7v_1","exiting":"_exiting_v3b7v_741","shiftPanelOut":"_shiftPanelOut_v3b7v_1","shiftPanelHeader":"_shiftPanelHeader_v3b7v_745","shiftPanelTitle":"_shiftPanelTitle_v3b7v_753","shiftPanelScore":"_shiftPanelScore_v3b7v_759","shiftPanelControls":"_shiftPanelControls_v3b7v_778","shiftFilterSelect":"_shiftFilterSelect_v3b7v_786","shiftClearButton":"_shiftClearButton_v3b7v_808","shiftList":"_shiftList_v3b7v_827","shiftListEmpty":"_shiftListEmpty_v3b7v_846","shiftItem":"_shiftItem_v3b7v_853","shiftItemValue":"_shiftItemValue_v3b7v_869","shiftItemContent":"_shiftItemContent_v3b7v_882","shiftItemDescription":"_shiftItemDescription_v3b7v_887","shiftItemTime":"_shiftItemTime_v3b7v_896","shiftItemReplay":"_shiftItemReplay_v3b7v_902"};